import { useParams } from "react-router-dom";
import CommandLayout from "../components/war-room/CommandLayout";
import Battlemap from "../components/war-room/Battlemap";
import CorpusScoreboard from "../components/war-room/CorpusScoreboard";
import SentinelStream from "../components/war-room/SentinelStream";
import ActionBoard from "../components/war-room/ActionBoard";

/**
 * The throne. Always-on panels (Battlemap, Scoreboard, Update Feed,
 * Sentinel Stream) plus the CommandBar. Issue commands from here to
 * enter sub-surfaces.
 */
function WarRoom() {
  const { caseId } = useParams<{ caseId: string }>();

  return (
    <CommandLayout caseId={caseId} variant="modes">
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
          <div className="lg:col-span-2">
            {caseId ? <Battlemap caseId={caseId} /> : null}
          </div>
          <div className="flex flex-col gap-4">
            {caseId ? <ActionBoard caseId={caseId} /> : null}
            <SentinelStream caseId={caseId} />
          </div>
        </div>
        {caseId ? <CorpusScoreboard caseId={caseId} /> : null}
      </div>
    </CommandLayout>
  );
}

export default WarRoom;
